// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'youtube';

export const Component = () => (
  <path d='M17.098 13.483c.288-.144.432-.383.432-.719 0-.336-.144-.575-.432-.719L10.106 7.64c-.287-.191-.575-.191-.91 0-.287.144-.431.431-.431.766v8.717c0 .335.144.623.431.766a.77.77 0 0 0 .431.144.921.921 0 0 0 .48-.144l6.991-4.406Zm7.424-2.778v4.12c0 .478-.048 1.1-.144 1.867a11.24 11.24 0 0 1-.287 2.012 3.11 3.11 0 0 1-.958 1.676 2.92 2.92 0 0 1-1.677.815c-2.394.239-5.46.335-9.195.335-3.735 0-6.8-.096-9.195-.335a2.927 2.927 0 0 1-1.677-.815 3.107 3.107 0 0 1-.958-1.676 11.311 11.311 0 0 1-.287-2.012C.048 15.926 0 15.303 0 14.824v-4.119c0-.478.048-1.101.144-1.867A11.24 11.24 0 0 1 .43 6.825a3.11 3.11 0 0 1 .958-1.677 2.92 2.92 0 0 1 1.677-.814C5.46 4.096 8.526 4 12.26 4c3.735 0 6.8.096 9.195.335.67.096 1.246.383 1.677.814a3.11 3.11 0 0 1 .958 1.677c.143.575.239 1.245.287 2.012.096.766.144 1.389.144 1.867Z' />
);

export const viewBox = '0 0 25 25';
